export default "__VITE_ASSET__DJ0W1aT4__"